import React from 'react';

import { isEmptyDoc } from '@townsquare/adf/is-empty-doc';
import { Context } from '@townsquare/context-identifier';
import { Renderer } from '@townsquare/renderer';

export const setEmbedClickHandler = () => {
	const clickHandler = (e: any) => {
		e.preventDefault();
		e.stopPropagation();

		// Either returns itself if it's an anchor element, or
		// traverse up its parents until this finds the first anchor element
		const target = e.target.closest('A');

		if (target?.tagName === 'A') {
			window.open(target.getAttribute('href'), '_blank', 'noreferrer');
		}
	};

	document.addEventListener('click', clickHandler);
	return () => document.removeEventListener('click', clickHandler);
};

export const isMissedUpdate = (update: { missedUpdate: boolean; updateType?: 'SYSTEM' | 'USER' }): boolean => {
	return Boolean(update.missedUpdate && update.updateType === 'SYSTEM');
};

export const renderContent = (adfDoc: string | null, placeHolder: React.ReactNode, context?: Context) => {
	return adfDoc && !isEmptyDoc(adfDoc) ? <Renderer document={adfDoc} context={context} /> : placeHolder;
};

export function whenNotViewReturn<T>(value: T, viewUuid: string | undefined) {
	return viewUuid ? undefined : value;
}
